import { errorValidation, maskList, geoIpLookup } from './utils';

let registerPhone = $('#register_phone');

/**
 * Init intlTelInput
 */
if (registerPhone.length) {
	$(window).on('load', function () {
		let phones_exist = false;
		[registerPhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});

		if (!phones_exist) {
			setTimeout(function () {
				geoIpLookup(countryCode => {
					[registerPhone].forEach(phoneInput => {
						phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
						const maskObj = maskList.find(mask => {
							return (
								mask.cc &&
								typeof mask.cc === 'string' &&
								mask.cc.toLowerCase() === countryCode.toLowerCase()
							);
						});
						if (maskObj) {
							console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
							phoneInput.inputmask('remove');
							phoneInput.inputmask({ mask: maskObj.mask });
						}
					});
				});
			}, 500);
		}
	});

	[registerPhone].forEach(phoneInput => {
		phoneInput.intlTelInput({
			initialCountry: 'auto', // Automatically detect the country
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: false,
			allowDropdown: false,
		});

		phoneInput.inputmasks({
			inputmask: {
				definitions: {
					'#': {
						validator: '[0-9]',
						cardinality: 1,
					},
				},
				//clearIncomplete: false,
				showMaskOnHover: false, // Show mask
				autoUnmask: true, // Remove country code when input is empty
			},
			match: /[0-9]/,
			replace: '#',
			list: maskList,
			listKey: 'mask',
			onMaskChange: function (maskObj, completed) {
				if (maskObj) {
					console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
					let countryCode = Array.isArray(maskObj.cc)
						? maskObj.cc[0].toLowerCase()
						: maskObj.cc.toLowerCase();
					phoneInput.intlTelInput('setCountry', countryCode);
				} else {
					console.log(`No mask found, applying default mask`);
					phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
				}
			},
		});

		// On blur: validate phone number
		phoneInput.focusout(function () {
			let fullNumber = phoneInput.intlTelInput('getNumber');
			let countryCode = phoneInput.intlTelInput('getSelectedCountryData').iso2;
			let isValidMask = registerPhone.inputmask('isComplete');
			if ($.trim(phoneInput.val())) {
				if (countryCode === 'md') {
					if (isValidMask) {
						console.log('isValidNumber');
					} else {
						phoneInput.addClass('_error');
						console.log('Invalid phone number:', fullNumber);
					}
				} else {
					if (phoneInput.intlTelInput('isValidNumber')) {
						console.log('isValidNumber');
					} else {
						phoneInput.addClass('_error');
						console.log('Invalid phone number:', fullNumber);
					}
				}
			}
		});

		// On keydown: reset
		phoneInput.keydown(function () {
			phoneInput.removeClass('_error');
		});
	});
}

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateRegisterPhone',
	function () {
		let countryCode = registerPhone.intlTelInput('getSelectedCountryData').iso2;
		let isValidMask = registerPhone.inputmask('isComplete');
		if (countryCode === 'md') {
			if (isValidMask) {
				return true;
			} else {
				return false;
			}
		} else {
			if (registerPhone.intlTelInput('isValidNumber')) {
				return true;
			} else {
				return false;
			}
		}
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Register
	$("form[name='register']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'register[name]': {
				required: true,
			},
			'register[surname]': {
				required: true,
			},
			'register[email]': {
				required: true,
				email: true,
			},
			'register[phone]': {
				required: true,
				validateRegisterPhone: true,
			},
			'register[password]': {
				required: true,
			},
			'register[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
			'register[mc]': {
				required: true,
			},
			'register[carrier]': {
				required: true,
			},
			'register[role]': {
				required: true,
			},
		},
		messages: {
			'register[name]': {
				required: window.translations.required,
			},
			'register[surname]': {
				required: window.translations.required,
			},
			'register[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'register[phone]': {
				required: window.translations.required,
			},
			'register[password]': {
				required: window.translations.required,
			},
			'register[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
			'register[mc]': {
				required: window.translations.required,
			},
			'register[carrier]': {
				required: window.translations.required,
			},
			'register[role]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
